import { CurrencyPipe } from '@angular/common';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IOffice } from '@shared/interfaces/office.interface';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { ApiService } from '@shared/services/api.service';
import { ProfileService } from '@shared/services/profile.service';
import {
  ConfirmEventType,
  ConfirmationService,
  MessageService,
} from 'primeng/api';
import { ITicket } from '@shared/interfaces/ticket.interface';
import { ITicketDetail } from '@shared/interfaces/ticket-detail.interface';
import { AutoComplete } from 'primeng/autocomplete';
import { UtilsService } from '@shared/services/utils.service';
import { environment } from 'src/environments/environment';
import { TokenService } from '@shared/services/token.service';
import { HttpClient } from '@angular/common/http';
import { PrinterService } from '@shared/services/printer.service';
import { subMenuItems } from './submenu';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
  providers: [MessageService, CurrencyPipe, ConfirmationService],
})
export class PaymentsComponent implements OnInit {
  @ViewChild('calculator') calculatorField!: ElementRef;
  @ViewChild('putMoneyInput') putMoneyInput!: ElementRef;
  // @ViewChild("displayText") displayText!: ElementRef;
  @ViewChild('searcherAutocomplete') searcherAutocomplete!: AutoComplete;

  ngAfterViewInit() {
    this.calculatorField.nativeElement.focus();
    this.putMoneyInput.nativeElement.addEventListener(
      'keydown',
      (event: KeyboardEvent) => this.handlePutMoneyKeydown(event)
    );
    // this.displayText.nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
    //   event.stopPropagation();
    // });
  }


  public office!: IOffice;
  public display: any = '';
  public firstValue: number | null = null;
  public action: string | null = null;
  public isResultDisplayed = false;
  public putMoney!: any;
  private lastButton: HTMLElement | null = null;
  public inOperation: boolean = false;
  public selectedPaymentType: string = '';
  public toggleConcept: boolean = false;
  public motivation!: string;
  public motivationInputEmpty: boolean = true;
  public ticketData: any[] = [];
  public confirmedEntry: boolean = false;
  public filteredBookings!: any[];
  public searcherCriteria: string = '';
  public amount: any = '';
  public change: number = 0;
  public billables: any[] = [];
  public me: any = null;
  public ticket: ITicket = {
    details: [],
  };
  public viewSelectedSizes: number = 0;
  public selectedSize: number = 0;
  public showSizes: boolean = false;
  public size!: string;
  public showOther: boolean = false;
  public showBooking: boolean = false;
  public otherDetail: { concept: string; unitPrice: number } = {
    concept: '',
    unitPrice: 0,
  };
  public inputSearchBooking: any = '';
  public bookings: any[] = [];
  public results_bookings: any[] = [];
  public totalAmountBooking: number = 0;
  public totalToPayAmountBooking: number = 0;
  public cashAmountBooking: any = 0;
  public selectedBookings: any = [];
  public indexBooking: number = -1;
  public selectedBooking: any = [];
  public isPayBookingCash: boolean = false;
  public totalSumTicket: string = '';
  public totalRestanteTickets: string = '';
  public toggleActividadesFlag = false;
  public services: any = [];
  public allowConfirm: boolean = false;
  public paymentTypeFlag: boolean = false;
  public showSaveDraft: boolean = false;
  public showListDraft: boolean = false;
  public nameAlias: string = '';
  public selectedTicketDraft: string = '';
  public ticketsDraft: any = [];
  public isCashOutflow: boolean = false;


  public subMenuItems: Array<IToolbarItem> = subMenuItems;

  public cashAmount: number = 0;
  public isCashIn: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private apiService: ApiService,
    private profileService: ProfileService,
    public utils: UtilsService,
    private changeDetector: ChangeDetectorRef,
    public tokenService: TokenService,
    public http: HttpClient,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private printerService: PrinterService
  ) { }

  cities!: any[];
  selectedCity!: any;

  async ngOnInit() {
    await this.printerService.connectToStoredDevice();

    this.apiService.getServicesList().subscribe((response: any) => {
      this.services = response;
    });

    this.profileService.getProfile().subscribe((response: any) => {
      this.me = response;
      this.office = this.me?.office;
      if (this.office) {
        this.apiService.getOffice(this.office.id).subscribe((response: any) => {
          this.office = response;
          if (this.office.cashier_status === 0) {
            this.router.navigate(['/panel/payments/cashclose']);
            return;
          }
        });
      }
    });

    this.apiService.getBillables().subscribe((response: any) => {
      this.billables = response;
    });

    this.apiService.openTicket().subscribe((response: any) => {
      this.ticket = response as ITicket;
      if (this.ticket.details?.length === 0) {
        this.ticket.details = [];
      }
    });


    if (this.route.snapshot.params['id']) {
      let bookingIdGet = this.route.snapshot.params['id'];


      this.apiService.get('/booking/get/' + bookingIdGet).subscribe((response: any) => {
        let bookingGet: any = response;

        if (bookingGet) {
          this.handleBooking();
          this.onSelectBooking(bookingGet);
        }
      });
    }

    // this.apiService.get('/booking/get').subscribe((response: any) => {
    //   this.bookings = response;
    //   this.bookings = this.bookings.filter(
    //     (item) => item.status_id != 1 && item.status_id != 6
    //   );
    //   if (this.route.snapshot.params['id']) {
    //     let bookingIdGet = this.route.snapshot.params['id'];
    //     let bookingGet: any = this.bookings.filter(
    //       (booking: any) => booking.id == bookingIdGet
    //     );

    //     if (bookingGet.length > 0) {
    //       this.handleBooking();
    //       this.onSelectBooking(bookingGet[0]);
    //     }
    //   }
    // });
  }

  @HostListener('click', ['$event'])
  onHostClick(event: MouseEvent) {
    if (this.lastButton) {
      this.lastButton.style.backgroundColor = '';
    }
    const target = event.target as HTMLElement;
    if (target.tagName === 'BUTTON') {
      target.style.backgroundColor = 'blue';
      this.lastButton = target;
      setTimeout(() => {
        target.style.backgroundColor = '';
      }, 300);
    }
  }

  reset() {
    this.display = '';
    this.firstValue = null;
    this.action = null;
    this.isResultDisplayed = false;
  }

  numClick(val: string) {
    if (this.isResultDisplayed) {
      this.display = '';
      this.isResultDisplayed = false;
    }

    const maxLength = 9;
    if (this.display.length >= maxLength) {
      return;
    }

    if (
      (val === '.' && this.display.includes('.')) ||
      (val === '.' && this.display === '')
    ) {
      return;
    }

    if (this.display === '0') {
      if (val === '.') {
        this.display += val;
      } else {
        this.display = val;
      }
    } else {
      this.display += val;
    }
  }

  backspace() {
    if (this.display.length > 0) {
      if (this.display.endsWith(' ')) {
        this.display = this.display.substring(0, this.display.length - 2);
      } else {
        this.display = this.display.substring(0, this.display.length - 1);
      }
    }
  }

  oper(action: string | null) {
    if (this.display === '' && action === '-') {
      this.display = '-';
      return;
    }

    if (this.display === '-') {
      return;
    }

    if (['+', '-', '*', '/', '%'].includes(this.display.trim().slice(-1))) {
      this.display = this.display.trim().slice(0, -1);
    } else {
      if (
        this.firstValue !== null &&
        this.action &&
        this.display !== '' &&
        action !== '%'
      ) {
        this.calculate();
        this.display = this.display;
        this.firstValue = parseFloat(this.display);
      } else if (
        this.firstValue !== null &&
        this.action == '*' &&
        this.display !== '' &&
        action == '%'
      ) {
        this.action = action;
        this.calculate();
        this.action = '';
        action = '';
      } else if (
        this.firstValue !== null &&
        this.action == '-' &&
        this.display !== '' &&
        action == '%'
      ) {
        this.action = '%-';
        this.calculate();
        this.action = '';
        action = '';
      } else if (
        this.firstValue !== null &&
        this.action == '+' &&
        this.display !== '' &&
        action == '%'
      ) {
        this.action = '%+';
        this.calculate();
        this.action = '';
        action = '';
      } else if (this.display !== '') {
        this.firstValue = parseFloat(this.display);
      }
    }

    this.display += ' ' + action;
    this.action = action;
    this.isResultDisplayed = true;
  }

  calculate() {
    if (this.firstValue === null || this.action === null) {
      return;
    }
    const secondValue = parseFloat(this.display);
    let result: number | undefined;

    switch (this.action) {
      case '+':
        result = this.firstValue + secondValue;
        break;
      case '-':
        result = this.firstValue - secondValue;
        break;
      case '*':
        result = this.firstValue * secondValue;
        break;
      case '/':
        result = this.firstValue / secondValue;
        break;
      case '%':
        result = (this.firstValue * secondValue) / 100;
        break;
      case '%-':
        result = this.firstValue - (this.firstValue * secondValue) / 100;
        break;
      case '%+':
        result = this.firstValue + (this.firstValue * secondValue) / 100;
        break;
    }

    if (result !== undefined) {
      this.display = result.toFixed(2);
      this.isResultDisplayed = true;
      this.firstValue = null;
      this.action = null; //
      this.inOperation = false;
    }
  }

  changeSign() {
    if (this.display.startsWith('-')) {
      this.display = this.display.substring(1);
    } else if (this.display !== '' && this.display !== '0') {
      this.display = '-' + this.display;
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyboardCalculator(event: KeyboardEvent) {
    event.stopImmediatePropagation();
    const key = event.key;

    switch (key) {
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        this.numClick(key);
        break;
      case '.':
        this.numClick('.');
        break;
      case '+':
      case '-':
      case '*':
      case '/':
      case '%':
        this.oper(key);
        break;
      case 'Backspace':
        this.reset();
        break;
      case 'Enter':
        this.calculate();
        break;
    }
  }

  changeToReturn(event: any) {
    // if (this.amount !== undefined ) {
    // if (!isNaN(this.amount) && !isNaN(this.putMoney)) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;

    // Permitir números del 0 al 9, el punto y las teclas permitidas
    if (!/[\d.]/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
      event.preventDefault();
      return;
    }

    // Permitir solo un punto decimal en la entrada
    if (keyPressed === '.' && event.target.value.includes('.')) {
      event.preventDefault();
      return;
    }

    if (this.putMoney != null && !isNaN(this.putMoney) && this.putMoney.trim() != '') {
      let totalRestanteTicketsAux = parseFloat(
        this.totalRestanteTickets.slice(1)
      );

      console.log('totalRestanteTicketsAux: ', totalRestanteTicketsAux);

      if (!this.selectedPaymentType) {
        this.paymentTypeFlag = true;
      } else {
        this.paymentTypeFlag = false;
      }

      let change_aux = 0;
      console.log('this.putMoney: ', isNaN(this.putMoney));
      if (totalRestanteTicketsAux < 0 && this.putMoney < 0) {
        console.log('totalRestanteTicketsAux: ', totalRestanteTicketsAux);
        console.log('this.putMoney: ', this.putMoney);
        change_aux = (this.putMoney - totalRestanteTicketsAux) * -1;
      } else if (totalRestanteTicketsAux < 0 && this.putMoney > 0) {
        change_aux = 0;
      } else {
        change_aux = this.putMoney - totalRestanteTicketsAux;
      }

      if (change_aux < 0) {
        this.change = 0;
      } else {
        this.change = Number(change_aux.toFixed(2));
      }

      if (
        totalRestanteTicketsAux <= 0 ||
        parseFloat(this.putMoney) <= 0 ||
        this.ticket.details.length == 0 ||
        isNaN(change_aux) ||
        isNaN(this.putMoney) ||
        this.putMoney.trim() == ''
      ) {
        this.allowConfirm = false;
      } else {
        this.allowConfirm = true;
      }
    } else {
      this.allowConfirm = false;
      this.change = 0;
      this.putMoneyInput.nativeElement.value = '';
    }

    this.validateConfirmEntry();
  }

  handlePutMoneyKeydown(event: KeyboardEvent) {
    event.stopPropagation();
  }

  paymentType(paymentType: string) {
    switch (paymentType) {
      case 'EFECTIVO':
        break;
      case 'TARJETA':
        break;
      case 'BIZUM':
        break;
      case 'TRANSFERENCIA':
        break;
    }

    this.paymentTypeFlag = false;
    this.updateDisplayTotal();
    this.selectedPaymentType = paymentType;
    let totalRestanteTicketsAux = parseFloat(
      this.totalRestanteTickets.slice(1)
    );
    let totalSumTicket = parseFloat(this.totalSumTicket.slice(1));

    this.validateConfirmEntry();
  }
  validateAddImportBooking() {
    let isValidated = false;

    if (this.cashAmountBooking > this.totalToPayAmountBooking ||
      ((this.totalToPayAmountBooking == 0 && this.cashAmountBooking >= 0) || this.cashAmountBooking == 0) ||
      (this.cashAmountBooking < 0 && this.cashAmountBooking > (this.selectedBooking.total_paid * -1))
    ) {
      isValidated = true;
    }

    return isValidated;
  }

  validateConfirmEntry() {
    let totalRestanteTicketsAux = parseFloat(
      this.totalRestanteTickets.slice(1)
    );
    if (
      (totalRestanteTicketsAux <= 0 && parseFloat(this.putMoney) > 0) ||
      (parseFloat(this.putMoney) <= 0 && totalRestanteTicketsAux > 0) ||
      this.ticket.details.length == 0 ||
      isNaN(this.change) ||
      isNaN(this.putMoney) ||
      this.putMoney.trim() == ''
    ) {
      this.allowConfirm = false;
    } else {
      this.allowConfirm = true;
    }
  }

  confirmEntry() {
    let amount = 0;

    if (!this.selectedPaymentType) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor, seleccione una forma de pago.',
      });
      return;
    }
    // if (amount < 0) {
    //   this.toggleConcept = true;
    //   this.motivationInputEmpty = true;
    //   this.confirmedEntry = true;
    // } else {
    //   this.motivationInputEmpty = false;
    //   //this.sendConfirm();
    // }
    let cashierEntry: any;

    if (this.change > 0) {
      if (this.putMoney > 0) {
        amount = parseFloat(this.putMoney) - this.change;
      } else {
        amount = parseFloat(this.putMoney) + this.change;
      }
    } else {
      amount = parseFloat(this.putMoney);
    }

    console.log('this.putMoney', this.putMoney);
    console.log('this.putMoney', this.putMoney);

    cashierEntry = {
      amount: amount,
      payment_method: this.selectedPaymentType,
      concept: '',
      concept_related: '',
      received: this.putMoney,
      is_group: this.existsBookingGroup(),
    };

    this.ticketData.push(cashierEntry);
    this.display = 0;
    this.putMoney = 0;
    this.selectedPaymentType = '';
    console.log('this.ticketData: ', this.ticketData);
    this.updateDisplayTotal();
  }

  resetCashierEntries() {
    this.ticketData = [];
    this.updateDisplayTotal();
    this.confirmedEntry = false;
    this.putMoney = 0;
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Transacciones reseteadas',
    });
  }

  onMotivationInputChange() {
    this.motivationInputEmpty =
      !this.motivation || this.motivation.trim().length === 0;
  }

  handleValidationErrors(validationData: any, additionalMessage: string = '') {
    Object.keys(validationData).forEach((key) => {
      const errorMessages = validationData[key];
      const messageToast = `${additionalMessage} ${errorMessages.join(', ')}`;
      this.messageService.add({
        severity: 'error',
        summary: 'Error de validación',
        detail: messageToast,
        life: 20000,
      });
    });
  }

  printTicket() {
    this.confirmedEntry = false;
    let is_group = this.existsBookingGroup();

    if (this.isPayBookingCash) {
      this.selectedBookings.forEach((booking: any) => {
        const bookingToUpdate = {
          total_paid: booking.total_paid,
        };
        this.apiService
          .post(`/booking/update-alone/${booking.id}`, bookingToUpdate)
          .subscribe(
            (response: any) => { },
            (error) => {
              console.log('Error crear entrada de caja', error);
            }
          );
      });

      this.selectedBookings = [];
    }

    this.apiService
      .post('/cashier-entry/save-all', {
        cashier_entries: this.ticketData,
        ticket: this.ticket,
      })
      .subscribe(
        (response: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Importe cobrado correctamente',
          });

          let ticket = {
            ticket: this.ticket,
            booking_id: null,
            is_group: is_group,
          };

          this.apiService.post('/ticket/generate', ticket).subscribe(
            (response: any) => {
              this.resetTicket();
              this.confirmedEntry = false;
              const printingType = this.printerService.printerIsConnected() ? 'print' : 'pdf';
              console.log('PRINT TYPE', printingType);
              if (!is_group) {
                // let tokenEncodeURL = encodeURIComponent(this.tokenService.getToken() ?? '');
                // window.open(`${environment.baseUrlWeb}/ticket/imprimir/${response.id}?token=${tokenEncodeURL}`, '_blank');
                let ticketData = `${environment.baseUrlWeb}/ticket/imprimir/${response.id
                  }?print_type=${printingType}&token=${this.tokenService.getToken()}`;

                if (printingType == 'pdf') {
                  console.log(printingType);
                  this.http.get(ticketData, { responseType: 'blob' }).subscribe(
                    (blob) => {
                      // Crear una URL de objeto para el Blob
                      const blobUrl = URL.createObjectURL(blob);

                      console.log(blob);

                      let iframe: HTMLIFrameElement =
                        document.createElement('iframe');
                      iframe.style.display = 'none';
                      iframe.src = blobUrl;
                      document.body.appendChild(iframe);
                      iframe.onload = () => {
                        iframe.contentWindow?.focus();
                        iframe.contentWindow?.print();
                      };
                    },
                    (error) => {
                      console.error('Error al cargar el PDF:', error);
                    }
                  );
                } else {
                  console.log(printingType);

                  this.http.get(ticketData).subscribe((response) => {
                    const ticket = response as string[];
                    this.printerService.printFullTicket(ticket);
                  });
                }
              }
            },
            (error) => {
              console.log('Error crear ticket', error);
            }
          );
        },
        (error) => {
          console.log('Error crear entrada de caja', error);
        }
      );
  }

  existsBookingGroup() {
    if (this.selectedBookings?.length > 0) {
      let bookingGroup = this.selectedBookings.find((booking: any) => {
        return booking.is_group == 1;
      });

      if (bookingGroup) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  updateDisplayTotal(resetTotal?: boolean) {
    console.log('entro a updateDisplay');
    const total = this.ticket.details.reduce((acc, detail) => {
      return acc + detail.unit_price * detail.units;
    }, 0);
    let totalCashierEntries = this.ticketData.reduce((total, entry) => {
      return total - parseFloat(entry.amount);
    }, total);

    if (totalCashierEntries == 0) {
      if (this.ticket.details.length > 0) {
        this.confirmedEntry = true;
      } else {
        this.confirmedEntry = false;
      }
    } else {
      this.confirmedEntry = false;
    }

    this.display = total.toFixed(2);
    this.totalSumTicket = '€' + total.toFixed(2);
    this.isCashOutflow = (totalCashierEntries <= 0) ? true : false;
    this.totalRestanteTickets = '€' + totalCashierEntries.toFixed(2);

    let existBooking = this.ticket.details.some((detail: any) => detail.booking_id != null);
    if (!existBooking) {
      this.isPayBookingCash = false;
    } else {
      this.isPayBookingCash = true;
    }
    console.log('this.isPayBookingCash', this.isPayBookingCash);
  }

  handleOthers() {
    this.showOther = true;
    this.updateDisplayTotal(true);
  }

  handleBooking() {
    this.showBooking = true;
    this.selectedBooking = null;
    this.totalToPayAmountBooking = 0;
    this.totalAmountBooking = 0;
    this.cashAmountBooking = 0;
    this.updateDisplayTotal(true);
  }

  handleBillable(index: any, item: any) {
    this.viewSelectedSizes = index;
    if (item.length > 1) {
      this.showSizes = true;
    } else {
      this.confirmBillableSize(0);
    }
  }

  confirmBillableSize(index: number) {
    if (this.existsBookingGroup()) {
      this.ticket.details = [];
      this.selectedBookings = [];
    }

    const details = this.ticket.details as Array<ITicketDetail>;
    let selectedBillable = this.billables[this.viewSelectedSizes][index];
    const match = details.findIndex(
      (detail: ITicketDetail) => detail.concept === selectedBillable.name
    );

    if (match === -1) {
      const size = selectedBillable.size
        ? ` ( talla ${selectedBillable.size} )`
        : '';
      const detail: ITicketDetail = {
        concept: `${selectedBillable.name}${size}`,
        units: 1,
        unit_price: selectedBillable.price,
        booking_id: null,
      };
      details.push(detail);
      this.viewSelectedSizes = 0;
      selectedBillable = null;
      this.showSizes = false;
    } else {
      details[match].units += 1;
    }
    this.ticket.details = details;
    this.updateDisplayTotal();
  }

  confirmOthers() {
    if (this.existsBookingGroup()) {
      this.ticket.details = [];
      this.selectedBookings = [];
    }

    const details = this.ticket.details as Array<ITicketDetail>;
    const detail: ITicketDetail = {
      concept: this.otherDetail.concept,
      units: 1,
      unit_price: this.otherDetail.unitPrice,
    };
    details.push(detail);
    this.ticket.details = details;
    this.updateDisplayTotal();
    this.showOther = false;
    this.otherDetail.concept = '';
    this.otherDetail.unitPrice = 0;
  }

  confirmBookingCash() {
    console.log('adios');
    if (this.existsBookingGroup() || this.selectedBooking.is_group) {
      this.ticket.details = [];
      this.selectedBookings = [];
    }

    let details = this.ticket.details.filter(
      (detail: any) => detail.booking_id != this.selectedBooking.id
    ) as Array<ITicketDetail>;
    const detail: ITicketDetail = {
      concept: `
        Reserva: ${this.selectedBooking.reference}
      `,
      units: 1,
      unit_price: this.cashAmountBooking,
      lock_units: true,
      booking_id: this.selectedBooking.id,
    };

    let total_paid_n = parseInt(this.selectedBooking.total_paid, 10);
    let cash_amount_booking = parseInt(this.cashAmountBooking, 10);
    let new_total_paid = total_paid_n + cash_amount_booking;

    this.ticket.details = this.ticket.details.filter(
      (detail: any) => detail.booking_id != this.selectedBooking.id
    );
    this.selectedBookings = this.selectedBookings.filter(
      (booking: any) => booking.id != this.selectedBooking.id
    );

    this.selectedBooking['total_paid'] = new_total_paid;
    this.selectedBookings.push(this.selectedBooking);

    details.push(detail);

    this.ticket.details = details;
    console.log('hola mundo');
    this.updateDisplayTotal();
    this.showBooking = false;
    this.display = '';
  }

  onSelectBooking($event: any) {
    let booking = $event.value ?? $event;
    console.log(booking, 'booking');
    this.totalToPayAmountBooking =
      parseFloat(booking.total_amount) - parseFloat(booking.total_paid);
    this.totalAmountBooking = parseFloat(booking.total_amount);
    this.selectedBooking = booking;
    console.log('booking', this.selectedBooking);
    this.searcherAutocomplete.value = booking.reference;
    this.changeDetector.detectChanges();
  }

  searchBooking(event: any) {
    const query = event.query.trim();
    const searchText = encodeURIComponent(query);
    if (searchText.length >= 3) {
      this.apiService.get('/booking/find/' + searchText).subscribe((response: any) => {
        console.log('response: ', response);
        this.results_bookings = response || [];
      });
    } else {
      this.results_bookings = [];
    }
  }

  deleteConcept(i: number) {
    if (this.ticket.details[i].booking_id) {
      this.selectedBookings = this.selectedBookings.filter(
        (booking: any) => booking.id != this.ticket.details[i].booking_id
      );
      if (this.selectedBookings.length == 0) {
        this.isPayBookingCash = false;
      }
    }
    this.ticket.details.splice(i, 1);
    this.updateDisplayTotal();
  }

  increaseUnits(index: number) {
    this.ticket.details[index].units++;
    this.updateDisplayTotal();
  }

  decreaseUnits(index: number) {
    if (this.ticket.details[index].units > 1) {
      this.ticket.details[index].units--;
    }
    this.updateDisplayTotal();
  }

  toggleActividades(booking_id: any) {
    let indexBooking = this.selectedBookings.findIndex(
      (booking: any) => booking.id === booking_id
    );
    this.indexBooking = indexBooking;
    this.toggleActividadesFlag = !this.toggleActividadesFlag;
  }

  getServiceName(serviceId: number) {
    const service = this.services.find(
      (profile: any) => profile.id === serviceId
    );
    return service ? service.name : 'Servicio Desconocido';
  }

  resetTicket() {
    this.apiService.openTicket().subscribe((response: any) => {
      this.ticket = response as ITicket;
      this.ticket.details = [];
    });
    this.display = '';
    this.putMoney = 0;
    this.change = 0;
    this.selectedPaymentType = '';
    this.isPayBookingCash = false;
    this.ticketData = [];
    this.ticket.details = [];
    this.updateDisplayTotal();
  }

  saveDraft(event: any) {
    event.preventDefault();
    console.log('this.ticket;', this.ticket);
    console.log('this.ticketData;', this.ticketData);
    this.apiService
      .post('/tickets/save/draft', {
        ticket: this.ticket,
        ticket_data: this.ticketData,
        alias: this.nameAlias,
      })
      .subscribe((response: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Ticket guardado como borrador correctamente',
        });
        this.showSaveDraft = false;
        this.resetTicket();
      });
  }

  onShowListDraft(event: any) {
    event.preventDefault();
    this.showListDraft = true;

    this.apiService.getTicketsDraft().subscribe((tickets: any) => {
      this.ticketsDraft = tickets;
      console.log(this.ticketsDraft, 'td');
      console.log(tickets, 'td');
    });
  }

  onSelectTicketDraft(event: any) {
    let ticket = event.option ?? event;
    this.ticketData = [];

    this.apiService.recoveryTicket(ticket.id).subscribe((response: any) => {
      this.ticket = response.ticket;
      this.ticketData = response.ticket_data ?? [];
      this.updateDisplayTotal();
      this.showListDraft = false;
    });
  }

  handleCashCashier(isCashIn: boolean) {
    this.isCashIn = isCashIn;

    this.cashAmount = 0;

    this.confirmationService.confirm({
      accept: () => {
        if (Number(this.cashAmount) > 0 && !this.isCashIn) {
          this.cashAmount *= -1;
        }
        if (Number(this.cashAmount) < 0 && this.isCashIn) {
          this.cashAmount *= -1;
        }
        this.http
          .post(`${environment.baseUrl}/cashier-entry/save`, {
            concept: (this.isCashIn) ? 'Entrada de cambio' : 'Pago por caja',
            received: this.cashAmount,
            amount: this.cashAmount,
            payment_method: 'EFECTIVO',
          })
          .subscribe(
            (response: any) => {
              this.cashAmount = 0;
              this.messageService.add({
                severity: 'success',
                summary: 'Exito',
                detail: 'Operación procesada, importe procesado',
              });
            },
            (error: any) => {
              this.cashAmount = 0;
              this.messageService.add({
                severity: 'error',
                summary: 'Cancelado',
                detail:
                  'Operación rechazada, hubo un error, comuníquese con el administrador',
              });
            }
          );
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.cashAmount = 0;
            this.messageService.add({
              severity: 'error',
              summary: 'Cancelado',
              detail: 'Operación rechazada',
            });
            break;
          case ConfirmEventType.CANCEL:
            this.cashAmount = 0;
            this.messageService.add({
              severity: 'error',
              summary: 'Cancelado',
              detail: 'Operación rechazada',
            });
            break;
        }
      },
    });
  }



  validateZeroInput(event: any) {
    if (this.putMoneyInput.nativeElement.value == 0) {
      this.putMoneyInput.nativeElement.value = '';
    }
  }
}
